import Vue from 'vue'
import VueI18n from 'vue-i18n'

const localesList = {
    en: "English",
    de: "Deutsch",
    la: "Español",
    br: "Português (Brasil)",
    fr: "Français",
    it: "Italiano",
    pl: "Polski",
    ru: "Русский",
    ua: "Українська",
    tr: "Türkçe",
    sc: "中文（简体）",
    tc: "中文（繁體）",
    ja: "日本語",
    vn: "Tiếng Việt",
    id: "Bahasa Indonesia",
    ms: "Bahasa Melayu",
    th: "ภาษาไทย",
    hi: "हिन्दी"
};

Vue.use(VueI18n);

function loadLocaleMessages() {
    const
        context = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.js$/i),
        locales = {};
    context.keys().forEach(locale => {
        const
            obj = require('./locales' + locale.slice(1)),
            localeTitle = locale.match(/([A-Za-z0-9-_]+)\./i)[1];
        obj.default.locales = localesList;
        locales[localeTitle] = obj.default;
    });
    return locales;
}

export default new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: loadLocaleMessages()
})